import * as Yup from 'yup'

export const AddPropertyValidationSchema = Yup.object({
  property_type_uuid: Yup.string().required('Property type is required'),
  // account_kyc_uuid: Yup.string().required('Property KYC is required'),
  property_title: Yup.string()
    .matches(/^[A-Za-z0-9\s]*$/, 'Only alphanumeric characters and spaces are allowed')
    .min(3, 'Minimum 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .required('Property title is required'),
  carpet_area: Yup.number()
    .typeError('Carpet area must be a number')
    .integer('Carpet area must be an integer')
    .positive('Carpet area must be a positive number')
    .min(1, 'Carpet area must be at least 1')
    .max(99999, 'Carpet area cannot be more than 99999')
    .required('Carpet area is required'),
  carpet_area_unit_uuid: Yup.string().required('Unit is required'),
  address_1: Yup.string()
    .min(3, 'Minimun 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .required('Address is required'),
  address_2: Yup.string()
    .min(3, 'Minimun 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .optional(),
  country_id: Yup.number().required('Country required'),
  province_id: Yup.number().required('Province / state is required'),
  city: Yup.string()
    .min(3, 'Minimum 3 characters required')
    .max(50, 'Maximum 50 characters are allowed')
    .required('City is required'),
  pin_zip: Yup.number()
    .typeError('Pincode must be a number')
    .positive('Pincode must be a positive number')
    .integer('Pincode must be an integer')
    .min(100000, 'Pincode must be at least 6 digits')
    .max(999999, 'Pincode cannot be more than 6 digits')
    .required('Pincode is required'),
  current_rent: Yup.number()
    .typeError('Expected Rent must be a number')
    .positive('Expected Rent must be a positive number')
    .integer('Expected Rent must be an integer')
    .required('Expected Rent is required'),
  isAgent: Yup.string().required('Please select one'),
  owner_name: Yup.string().when('isAgent', (val, schema) => {
    if (val === 'true') return Yup.string().required('Owner name is required')
    else return Yup.string().notRequired()
  }),
  owner_email_id: Yup.string().when('isAgent', (val, schema) => {
    if (val === 'true')
      return Yup.string().required('Owner email address is required').email('Wrong email format')
    else return Yup.string().notRequired()
  }),
  owner_contact_number: Yup.string().when('isAgent', (val, schema) => {
    if (val === 'true') return Yup.string().required('Owner phone number is required')
    else return Yup.string().notRequired()
  }),
  property_usage_type: Yup.number().required('Category is required'),
  property_furnishing_status: Yup.number().required('Furnishing type is required'),
  sub_unit_available: Yup.boolean().required('Subdivisions type is required'),
})
